import { PerkItemType } from "@/shared/modules/PurchaseSeats/SelectPerks/perks.types";
import { CartManagerState } from "../store/data/purchaseSeats/cartManager";
import { InventoryType } from "../store/data/types";
import { api } from "./api";
import { endpoints } from "./endpoints";

export const getPerksApi = async (payload: {
  teamSchema: string;
  cart: CartManagerState["cart"];
}) => {
  return await api.post(endpoints.getPerks, payload);
};

export const managePerksApi = async (payload: {
  teamSchema: string;
  sessionId: string;
  cartId?: number;
  cart: {
    eventCode: string;
    products: InventoryType[];
    perks?: PerkItemType[];
  }[];
  cartTotalAmount?: number;
  orderServiceFee?: number;
  allInPrice?: number;
  basePrice?: number;
  serviceFee?: number;
}) => {
  return await api.post(endpoints.managePerks, payload);
};
